// 客服

const urlName = '/saas/v1'
export default API => ({
    getServiceAccessId(params) {
        return API({
            params,
            method:  'get',
            url: `${urlName}/customer/getDefaultConfig`,
        })
    },
    getServiceConfig(params) {
        return API({
            params,
            method:  'post',
            url: `${urlName}/customer/getPageConfig`,
        })
    },
})